import { createServerFn } from "@tanstack/react-start";

export type GiphyGif = {
  id: string;
  url: string; // fixed_height / preview url used for grid
  full_url: string; // downsized url used when picked
  width: number;
  height: number;
};

type GiphyRawItem = {
  id: string;
  images: {
    fixed_height: { url: string; width: string; height: string };
    downsized_medium?: { url: string };
    original: { url: string };
  };
};

async function callGiphy(endpoint: "search" | "trending", params: Record<string, string>) {
  const apiKey = process.env.GIPHY_API_KEY;
  if (!apiKey) throw new Error("Integração GIPHY não configurada");
  const qs = new URLSearchParams({
    api_key: apiKey,
    limit: "24",
    rating: "pg-13",
    lang: "pt",
    bundle: "messaging_non_clips",
    ...params,
  });
  const url = `https://api.giphy.com/v1/gifs/${endpoint}?${qs.toString()}`;
  const res = await fetch(url);
  if (!res.ok) throw new Error(`Giphy ${res.status}`);
  const json = (await res.json()) as { data: GiphyRawItem[] };
  return (json.data ?? []).map<GiphyGif>((g) => ({
    id: g.id,
    url: g.images.fixed_height.url,
    full_url: g.images.downsized_medium?.url ?? g.images.original.url,
    width: Number(g.images.fixed_height.width),
    height: Number(g.images.fixed_height.height),
  }));
}

export const searchGiphy = createServerFn({ method: "GET" })
  .inputValidator((i: { query?: string }) => ({ query: (i.query ?? "").trim().slice(0, 80) }))
  .handler(async ({ data }) => {
    if (!data.query) return callGiphy("trending", {});
    return callGiphy("search", { q: data.query });
  });
